module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/th_1-dc5e1b249bea7e3fb560327a18fafbe9.jpg";